// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JC44","label":"styles_label__1wMPK"};